import { useState, useRef, useEffect } from "react";
import classNames from "classnames";

import { AppHeader } from "../../components/header/header";
import { LoadingIndicator } from "../../components/utilities/loader";
import { useAuth } from "../../services/authentication/authentication.context";
import { PillInputBox, PillTextArea } from "../../components/forms/form-inputs";
import { AppAlert } from "../../components/utilities/app-alert";
import { useLesson } from "../../services/lessons/lessons.context";
import "../../styles/eval.css";
import { PillDropdown } from "../../components/forms/dropdown-select";
import { useLocation } from "react-router-dom";
import { formatUrl } from "../../_helpers/parseurl";
import { AppFooter } from "../../components/footer/footer";

export const UpdateQuestion = () => {

    const { isLoading, token } = useAuth();
    const { loading, updateEvaluationQuestion } = useLesson();
    const {question, qId} = useLocation().state;

    const letterOpttions = ['A', 'B', 'C', 'D'];

    const [evalData, setEvalData] = useState({
        question: question?.question,
        options: question?.options,
        answer: question?.answer
    });
    const [onAlert, setOnAlert] = useState();
    const [filePrev, setFilePrev] = useState();

  

    


    const fileRef = useRef();


    const uploadFile = (e) => {
        if (e.target.files[0].type.split("/")[0].toLowerCase() !== "image") {
            setOnAlert({
                caption: "Error!",
                message: "Invalid file format! Please upload a file of type image",
                accept: "Ok",
                onAccept: () => setOnAlert()
            })
            return;
        }
        setFilePrev(URL.createObjectURL(e.target.files[0]));
        setEvalData((d) => ({...d, documentFile: e.target.files[0]}));
    }


   
    const handleSubmit = async (e) => {
        e.preventDefault();
        const resp = await updateEvaluationQuestion(question?._id, evalData, qId, token);
        setOnAlert({
            caption: "Success!",
            message: resp.message,
            accept: "Ok",
            onAccept: () => {
                setOnAlert()
            }
        })
    }

    
   useEffect(() => {
    console.log(question)
   }, [question])


    return (
        <div className="min-v">
            <AppHeader />
            {(isLoading || loading) && <LoadingIndicator />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    onAccept={onAlert.onAccept}
                    closeAlert={() => setOnAlert()}
                />
            )}
            <div className="flx-cnt-pg">
                <div className={classNames("cap","lg-txt")}>Add a question</div>
                <div className="sm-sp" />
                <div className="flx-rw">
                <form className="add-form" onSubmit={(e) => handleSubmit(e)}>
                    <PillTextArea
                        type={"text"}
                        name={"question"}
                        caption={"Question"}
                        onChange={(e) => setEvalData((data) => ({...data, question: e.target.value})) }
                        placeholder={"Type the question here"}
                        value={evalData?.question}
                    />
                    <div className="option-cap">Add answer Options</div>
                    {question?.options?.map((opt,indx) => (
                        <PillInputBox
                            type={"text"}
                            value={evalData?.options[indx]}
                            caption={letterOpttions[indx]}
                            onChange={(e) => {
                                let tmp = evalData?.options;
                                tmp[indx] = e.target.value;
                                setEvalData((data) => ({...data, options: tmp}))
                            } }
                            key={indx}
                        />
                    ))}
                    {filePrev && (
                        <div className="video-prev-box">
                            < img src={filePrev} width={250} alt="" />
                        </div>
                    )}
                    <button 
                        className="sel-click"
                        onClick={(e) => {
                            e.preventDefault();
                            fileRef.current.click();
                        }}
                    > 
                        Add an image (if necessary)
                    </button>
                    <input 
                        type="file" 
                        name="avatar"  
                        onChange={(e) => uploadFile(e)}
                        className="file-sel"
                        ref={fileRef}
                    />
                    <PillDropdown
                        placeholder={"Selected correct option"}
                        data={letterOpttions}
                        onChange={(e) => setEvalData((data) => ({...data, answer: e.target.value}))}
                        name={'answer'}
                        value={evalData?.answer}
                    />
                    
                    <button 
                        className={
                            classNames(
                                "form-button",
                                'pill-input-box',
                            )
                        }
                        onClick={async (e) => await handleSubmit(e)}
                    >
                        Submit
                    </button>
                </form>
                </div>
            </div>
            <AppFooter />
        </div>
    )
}